module.exports = __webpack_public_path__ + "static/media/Flik4.37d21462.pdf";